import { SummaryRow } from '../../../Summary/SummaryRow';
import { VQ } from '../../../../store/student/types';
import { IVisaPrepForm } from '../../../../types';
import { boolToYesNo } from '../../../../utilities/formatting';
import { useTranslation } from "react-i18next";

function VisaPrepDeclarationsStep1(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_CRIMINAL_CHARGES}
        label={t('forms.visa:hasCriminalCharges')}
        fullLabel={
          'Have you ever been charged in any country with a criminal offence for which you have not yet been tried in the court (including traffic offences)?'
        }
        value={boolToYesNo(props.hasCriminalCharges)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_TERRORISM_INVOLVEMENT}
        label={t('forms.visa:terrorismInvolvement')}
        fullLabel={'Have you ever been involved in, supported or encouraged terrorist activities in any country?'}
        value={boolToYesNo(props.hasTerrorismInvolvement)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_TERRORISM_CONNECTION}
        label={t('forms.visa:terrorismConnection')}
        fullLabel={
          'Have you ever been a member of, or given support to, an organisation that has been connected with terrorism?'
        }
        value={boolToYesNo(props.hasTerrorismConnection)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_TERRORISM_JUSTIFIED}
        label={t('forms.visa:justifiedTerrorism')}
        fullLabel={
          'Have you ever, by any means or medium, expressed views that justify or glorify terrorist violence, or that may encourage others to commit acts of terrorism or other serious criminal acts?'
        }
        value={boolToYesNo(props.hasTerrorismJustified)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_WAR_CRIMES}
        label={t('forms.visa:warCrimes')}
        fullLabel={
          'In times of either peace or war have you ever been involved in, or suspected of involvement in, war crimes, crimes against humanity or genocide?'
        }
        value={boolToYesNo(props.hasWarCrimes)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_BAD_ACTIVITIES}
        label={t('forms.visa:badActivities')}
        fullLabel={
          'Have you engaged in any other activities that might indicate that you may not be admitted to the UK?'
        }
        value={boolToYesNo(props.hasBadActivities)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={`${VQ.LANGUAGE}`}
        value={props.language}
        label={t('forms.visa:interviewLanguage')}
        fullLabel={'If UKVI need to interview you, what language would you like to use in the interview?'}
      />
    </>
  );
}

export default VisaPrepDeclarationsStep1;
